export function createShareUrl({ url }: { url?: string }) {
  const p = new URLSearchParams();
  if (url) {
    p.set('u', url);
  }
  return `https://www.facebook.com/sharer/sharer.php?${p.toString()}`;
}
